import {
  Box,
  Typography,
} from '@mui/material'
import { FC } from 'react'
import { EventGrid } from '../../components/EventGrid/EventGrid'

export const Events: FC = () => {
  return (
    <Box sx={{ height: 'calc(100vh - 95px)' }}>
      <Typography variant="h1">
        View and Edit Events
      </Typography>
      <EventGrid />
    </Box>
  );
}